module.exports = "/assets/data/207aa1e114c102f58a88c910f428f6f2-OL8.data.json";